module.exports = {"350423100":"龙津镇","350423101":"嵩溪镇","350423102":"嵩口镇","350423103":"灵地镇","350423104":"长校镇","350423105":"赖坊镇","350423106":"林畲镇","350423201":"温郊乡","350423203":"田源乡","350423204":"沙芜乡","350423206":"余朋乡","350423208":"李家乡","350423209":"里田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350423.json
// module id = 1299
// module chunks = 0